module.exports = __webpack_public_path__ + "dddee8d435b08a6ec2b6c40e2a3c269e.pdf";